import React, { useEffect, useState, useLayoutEffect } from "react";

// libraries
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// components
import colors from "core/colors";
import OffsetGrid from "core/OffsetGrid";
import SectionContainer from "core/SectionContainer";
import Form from "./Form";
import breakpoints from "core/breakpoints";
import CheckoutHeader from "subscriptions/components/CheckoutHeader";

// helpers
import { useViewport } from "js/hooks/useViewport";
import { useAuth } from "frontend/hooks/useAuth";
import { useCurrentUserActiveSub } from "frontend/hooks/useCurrentUserActiveSub";
// styles
import { CheckoutPageHeading } from "subscriptions/styles";

// data
import { initialForm } from "subscriptions/data";

const stripePromise = loadStripe(window._nounConfig.stripePublishable);

const NounProCheckout = ({ match }) => {
    const { planType } = match.params;
    const { browserWidth } = useViewport();
    const [form, setForm] = useState(initialForm);
    const { currentUser = {} } = useAuth();

    const { hasSubscription, activeSubscription } = useCurrentUserActiveSub();

    // if the user does not have a subscription, activeSubscription will be falsyy
    const { cancelAtPeriodEnd = false } = activeSubscription || {};

    useLayoutEffect(() => {
        if (hasSubscription && !cancelAtPeriodEnd) {
            const { username } = currentUser;
            window.location.replace(`/${username}/settings/billing/`);
        }
    }, [hasSubscription, cancelAtPeriodEnd]);

    useEffect(() => {
        // We need to manually take control of the browsers scrollRestoration
        window.history.scrollRestoration = "manual";

        if (window.pageYOffset !== 0) {
            window.scrollTo(0, 0);
        }
    }, []);

    return (
        <SectionContainer
            bgColor={colors.secondary.orca}
            removeLeftRightPadding={browserWidth < breakpoints.beforeTablet.px}
        >
            <CheckoutPageHeading
                type="h1"
                size="xl"
                headingColor={colors.primary.diamond}
                alignment="center"
                topSpacing="none"
                bottomSpacing="4xl"
            >
                Get Started with NounPro
            </CheckoutPageHeading>
            <OffsetGrid sm={12} md={12} lg={8}>
                <SectionContainer
                    bgColor={colors.primary.snow}
                    topSpacing="2xl"
                    bottomSpacing="2xl"
                >
                    <OffsetGrid sm={12} md={8} lg={6}>
                        <CheckoutHeader />
                        <Elements stripe={stripePromise}>
                            <Form
                                showOrderSummary={false}
                                planType={planType}
                                setForm={setForm}
                                form={form}
                            />
                        </Elements>
                    </OffsetGrid>
                </SectionContainer>
            </OffsetGrid>
        </SectionContainer>
    );
};

export default NounProCheckout;
